import React from "react";

function LoadingSpinner() {
  return <h1 className="text-center loading-text">Chargement</h1>;
}

export default LoadingSpinner;
